import React from 'react'

import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'
import { useParams } from 'react-router'
import { useRequestState } from 'src/legacy_modules/server/use-request-state'
import { ModalCancelButton } from 'src/lib/chakra-theme/components'
import { useMirohaToast } from 'src/lib/chakra-theme/components/toast/use-miroha-toast'

import { submitDelete } from './request'
import { trialIdParamName } from '../../../../../trial-detail'
import { useTemplateEntities } from '../../../../template-entities-context'
import { templateIdParamName } from '../../template-detail'

type Props = {
  onClose: () => void
}

export const DeleteContainer: React.FC<Props> = props => {
  const { trialUid = '', templateUid = '' } = useParams<{
    [templateIdParamName]: string
    [trialIdParamName]: string
  }>()

  const { getTemplate, deleteTemplate } = useTemplateEntities()
  const template = getTemplate(templateUid)

  const { request, requesting } = useDeleteTemplate({
    trialUid,
    templateUid,
  })

  const toast = useMirohaToast()

  const onSubmit = () => {
    const submit = async () => {
      try {
        await request()
        toast({
          status: 'success',
          title: 'テンプレートを削除しました。',
        })
        deleteTemplate(templateUid)
        props.onClose()
      } catch (error) {
        toast({
          status: 'error',
          title: error.message,
        })
      }
    }

    submit()
  }

  if (!template) return null

  return (
    <Modal isOpen onClose={props.onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalHeader>テンプレートを削除</ModalHeader>
        <ModalBody>
          <Text>
            <Text as="span" fontWeight="bold">
              {template.title}
            </Text>
            を削除します。
          </Text>
        </ModalBody>
        <ModalFooter>
          <ModalCancelButton />
          <Button colorScheme="red" onClick={onSubmit} isDisabled={requesting}>
            削除する
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

const useDeleteTemplate = ({
  trialUid,
  templateUid,
}: {
  trialUid: string
  templateUid: string
}) => {
  const { requestDone, requestStarted, requesting } = useRequestState()

  const request = async () => {
    try {
      requestStarted()
      await submitDelete({ trialUid, templateUid })
      requestDone()
    } catch (error) {
      throw error
    }
  }

  return {
    request,
    requesting,
  }
}
